import React, { FunctionComponent, useEffect } from 'react';
import { generateGalleryItemMachine } from 'src/machines/galleryItemMachine';
import { ModelScreenshot } from 'src/generated/graphql';
import { useMachine } from '@xstate/react';
import EnhancedScreenshot from './EnhancedScreenshot';
import Screenshot from './Screenshot';
import { Row, Line, DeleteButton } from './styled';

interface GallerySidebarRowProps {
  deleteScreenshot: (id: string) => {};
  showImage: (id: string, isEnhanced: boolean) => {};
  screenshot: ModelScreenshot;
}

const GallerySidebarRow: FunctionComponent<GallerySidebarRowProps> = (
  props,
) => {
  const { screenshot, showImage, deleteScreenshot } = props;
  const {
    placeholderUrl,
    id,
    rendering: { id: renderingId, percentDone = 0 },
  } = screenshot;
  const [current, send] = useMachine(generateGalleryItemMachine(screenshot));
  const {
    enhancedImageUrl,
    isRenderingFailed,
    isRenderingComplete,
    isRenderingInProgress,
    isRenderingQueued,
  } = current.context as any;

  useEffect(() => {
    send('UPDATE_STATUS', { screenshot });
  }, [screenshot.updatedAt, screenshot.rendering.state]);

  return (
    <>
      <Row>
        <Screenshot
          imageUrl={placeholderUrl}
          showImage={() => showImage(id, false)}
        />
        <EnhancedScreenshot
          imageUrl={enhancedImageUrl}
          percentDone={percentDone!}
          isRenderingFailed={isRenderingFailed}
          isRenderingComplete={isRenderingComplete}
          isRenderingInProgress={isRenderingInProgress}
          isRenderingQueued={isRenderingQueued}
          showImage={() => showImage(renderingId, true)}
        />
        <DeleteButton
          data-selenium="deleteScreenshotButton"
          onClick={() => deleteScreenshot(screenshot.id)}
        >
          Delete
        </DeleteButton>
        <Line />
      </Row>
    </>
  );
};

export default GallerySidebarRow;
